import { intersection } from 'lodash';
import { IssueStatus, IssueState } from 'shared/constants/issues';

export const filterIssues = (projectIssues, filters) => {
  const { searchTerm, userIds, srcOrgIds } = filters;
  let issues = projectIssues;

  if (searchTerm) {
    searchTerm.trim().split(/\s+/);
    issues = issues.filter(
      (issue) =>
        issue.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        issue.patientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        issue.srcOrgName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
  if (userIds.length > 0) {
    issues = issues.filter(
      (issue) => intersection(issue.userIds, userIds).length > 0
    );
  }
  if (srcOrgIds.length > 0) {
    issues = issues.filter((issue) => srcOrgIds.includes(issue.srcOrgId));
  }
  return issues;
};

export const getSortedListIssues = (issues, status) => {
  if (status === IssueStatus.DONE) {
    return issues
      .filter((issue) => issue.status === status)
      .sort((a, b) => a.id - b.id);
  } else {
    return issues
      .filter((issue) => issue.status === status)
      .sort(function (a, b) {
        if (a.state === b.state) {
          if (a.priority === b.priority) {
            return a.listPosition - b.listPosition;
          }
          return a.priority < b.priority ? 1 : -1;
        }
        return a.state === IssueState.NORMAL ? 1 : -1;
      });
  }
};
